import React from "react";
import { useSelector } from "react-redux";
import { DOCUMENT_STATUSES } from "../../../../../constants/constants";
import styles from "./ArchiveLayer.module.css";
import { translate } from "../../../../../../../common/providers";
import { icon, IconComponent } from "../../../../../../../common/components";

interface ArchiveLayerProps {
	style: React.CSSProperties;
}
const ArchiveLayer: React.FC<ArchiveLayerProps> = ({ style }) => {
	const isArchived = useSelector(({ srDocument }) => srDocument.status === DOCUMENT_STATUSES.ARCHIVED);
	const selectedMenu = useSelector(({ srPdf }) => srPdf.selectedMenu);
	if (isArchived) {
		return (
			<div className={styles.archive__banner} data-navbar-open={selectedMenu !== 0} style={style}>
				<div>
					<IconComponent color="var(--blue-500)" icon={icon.faBoxArchive} size="xs" />
				</div>
				<div className={styles.archive__text}>
					<div className={styles.archive__title}>
						{translate("smart-review.document.archive.banner.title")}
					</div>
					<div className={styles.archive__message}>
						{translate("smart-review.document.archive.banner.message")}
					</div>
				</div>
			</div>
		);
	}
	return null;
};

export default ArchiveLayer;
